import { SchemaType } from '../type';
export const schema = {
    id: 'xy_flow',
    name: '工作流',
    type: SchemaType.Indivisible,
    identityField: 'name',
};
